import actions from './actionsShared';

export const loadLocale = (
  locale,
  localesPath,
  localeModule,
  appendMessages
) => ({
  type: actions.LOAD_LOCALE,
  locale,
  localesPath,
  localeModule,
  appendMessages
});
export const setLocaleMessages = (locale, messages) => ({
  type: actions.SET_LOCALE_MESSAGES,
  locale,
  messages
});
export const appendLocaleMessages = (locale, messages) => ({
  type: actions.APPEND_LOCALE_MESSAGES,
  locale,
  messages
});

export const setSupportedLocales = supportedLocalesArray => ({
  type: actions.SET_SUPPORTED_LOCALES,
  payload: {supportedLocales: supportedLocalesArray}
});
